export default __webpack_public_path__ + "static/media/store-icon.dcd663fa.svg";